import React from 'react';

function NotFoundIcon({ ...props }) {
  return (
    <svg
      width="264"
      height="123"
      viewBox="0 0 264 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M84.8684 102.86H72.3884V120.62H51.1084V102.86H0.0683594V85.58L54.4684 2.37999H72.3884V83.82H84.8684V102.86ZM51.1084 83.82V38.22L21.6684 83.82H51.1084Z"
        fill="white"
      />
      <path
        d="M173.6 81.1C173.6 107.66 158.24 122.7 135.04 122.7C110.72 122.7 94.3996 107.66 94.3996 81.1V40.94C94.3996 15.98 109.76 0.299988 134.08 0.299988C158.08 0.299988 173.6 15.82 173.6 39.82V81.1Z"
        fill="white"
      />
      <path
        d="M263.931 102.86H251.451V120.62H230.171V102.86H179.131V85.58L233.531 2.37999H251.451V83.82H263.931V102.86ZM230.171 83.82V38.22L200.731 83.82H230.171Z"
        fill="white"
      />
      <path
        d="M125.219 57.5845C123.409 57.5845 122.203 56.3424 122.203 54.4794V41.4383C122.203 39.5753 123.409 38.3333 125.219 38.3333C127.028 38.3333 128.234 39.5753 128.234 41.4383V54.4794C128.234 56.0319 126.726 57.5845 125.219 57.5845ZM145.12 54.4794V41.4383C145.12 39.5753 143.914 38.3333 142.105 38.3333C140.296 38.3333 139.09 39.5753 139.09 41.4383V54.4794C139.09 56.3424 140.296 57.5845 142.105 57.5845C143.914 57.5845 145.12 56.0319 145.12 54.4794ZM113.76 82.1141C117.077 76.5251 125.219 72.7991 133.963 72.7991C142.406 72.7991 150.246 76.2146 153.865 81.4931C154.77 83.0456 156.579 83.3561 158.087 82.4246C159.594 81.4931 159.896 79.6301 158.991 78.0776C154.167 70.9361 144.819 66.589 134.265 66.589C123.108 66.589 113.157 71.5571 108.936 79.0091C108.031 80.5616 108.634 82.4246 109.84 83.3561C110.443 83.6666 110.745 83.6666 111.348 83.6666C111.951 83.6666 113.157 83.0456 113.76 82.1141Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default NotFoundIcon;
